import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeedbackRoutingModule } from './feedback-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeedbackComponent } from './feedback.component';
import { ThankyouComponent } from './components/thankyou/thankyou.component';
import { StoreModule } from '@ngrx/store';
import * as fromShared from '../shared/store/reducers';
import { EffectsModule } from '@ngrx/effects';
import { SharedEffects } from '../shared/store/effects/shared.effects';


@NgModule({
  declarations: [FeedbackComponent, ThankyouComponent,],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    FeedbackRoutingModule,
    FeedbackRoutingModule,
    StoreModule.forFeature(fromShared.sharedFeatureKey,fromShared.sharedReducer),
    EffectsModule.forFeature([SharedEffects])
  ]
})
export class FeedbackModule { }
